<template>
    <div>
        <div class="row">
            <div class="form-group col-md-4">
                <label for="patient_last">Last Name <small class="text-muted"><em>(Required)</em></small></label>
                <input id="patient_last" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('patient_last') }]" name="patient_last" v-model="patient.last_name" :disabled="readonly" required autofocus>
                <span v-if="hasError('patient_last')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('patient_last')"></strong>
                </span>
            </div>
            <div class="form-group col-md-4">
                <label for="patient_first">First Name <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="patient_first" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('patient_first') }]" name="patient_first" v-model="patient.first_name" :disabled="readonly">
                <span v-if="hasError('patient_first')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('patient_first')"></strong>
                </span>
            </div>
            <div class="form-group col-md-4">
                <label for="patient_middle">Middle Name <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="patient_middle" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('patient_middle') }]" name="patient_middle" v-model="patient.middle_name" :disabled="readonly">
                <span v-if="hasError('patient_middle')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('patient_middle')"></strong>
                </span>                
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-3">
                <label for="patient_ssn">Social Security Number <small class="text-muted"><em>(Optional)</em></small></label>
                <ssn-input id="patient_ssn" v-bind:class="['form-control', {'is-invalid' : hasError('patient_ssn') }]" name="patient_ssn" v-model="patient.ssn" :disabled="readonly"></ssn-input>
                <span v-if="hasError('patient_ssn')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('patient_ssn')"></strong>
                </span>                  
            </div>

            <div class="form-group col-md-3">
                <label for="patient_dob">Date of Birth <small class="text-muted"><em>(Required)</em></small></label>
                <div class="input-group">
                    <input id="patient_dob" type="date" v-bind:class="['date form-control', {'is-invalid' : hasError('patient_dob') }]" name="patient_dob" v-model="patient.dob" :disabled="readonly">
                    <div class="input-group-append">
                        <span class="input-group-text fas fa-calendar pt-2"></span>
                    </div>
                    <span v-if="hasError('patient_dob')" class="invalid-feedback" role="alert">
                        <strong v-text="errorText('patient_dob')"></strong>
                    </span>                    
                </div>                  
            </div>

            <div class="form-group col-md-3">
                <label for="injury_date">Date of Injury <small class="text-muted"><em>(Optional)</em></small></label>               
                <div class="input-group">
                    <input id="injury_date" type="date" v-bind:class="['form-control', {'is-invalid' : hasError('injury_date') }]"  name="injury_date" v-model="patient.injury_date" :disabled="readonly" required>
                    <div class="input-group-append">
                        <span class="input-group-text fas fa-calendar pt-2"></span>
                    </div>
                    <span v-if="hasError('injury_date')" class="invalid-feedback" role="alert">
                        <strong v-text="errorText('injury_date')"></strong>
                    </span>                                 
                </div>                
            </div>

            <div class="form-group col-md-3">
                <label for="patient_phone">Phone <small class="text-muted"><em>(Optional)</em></small> </label>
                <div class="input-group">
                    <telephone-input id="patient_phone" v-bind:class="['form-control', {'is-invalid' : hasError('patient_phone') }]" name="patient_phone" v-model="patient.phone" :disabled="readonly"></telephone-input>
                    <div class="input-group-append">
                        <span class="input-group-text fas fa-phone pt-2"></span>
                    </div>
                    <span v-if="hasError('patient_phone')" class="invalid-feedback" role="alert">
                        <strong v-text="errorText('patient_phone')"></strong>
                    </span>                                 
                </div>                   
            </div>            
        </div>
        <div class="row">
            <div class="form-group col-md-5">
                <label for="patient_address">Address <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="patient_address" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('patient_address') }]" name="patient_address" v-model="patient.address" :disabled="readonly">
                <span v-if="hasError('patient_address')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('patient_address')"></strong>
                </span>                 
            </div>
            <div class="form-group col-md-3">
                <label for="patient_city">City <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="patient_city" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('patient_city') }]" name="patient_city" v-model="patient.city" :disabled="readonly">
                <span v-if="hasError('patient_city')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('patient_city')"></strong>
                </span>                 
            </div>
            <div class="form-group col-md-2">
                <label for="patient_state">State <small class="text-muted"><em>(Optional)</em></small></label>
                <select id="patient_state" v-bind:class="['custom-select', {'is-invalid' : hasError('patient_state') }]" name="patient_state" v-model="patient.state" :disabled="readonly">
                    <option v-for="state in states" :key="state.code" :value="state.code" v-text="state.name"></option>
                </select>
                <span v-if="hasError('patient_state')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('patient_state')"></strong>
                </span>                  
            </div>
            <div class="form-group col-md-2">
                <label for="patient_postal_code">Postal Code <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="patient_postal_code" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('patient_postal_code') }]" name="patient_postal_code" v-model="patient.postal_code" :disabled="readonly">
                <span v-if="hasError('patient_postal_code')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('patient_postal_code')"></strong>
                </span>                 
            </div>            
        </div>
        <div>
            <div v-if="attorneyAlert" class="alert alert-warning alert-dismissible fade show" role="alert">
                <strong>Attorney information has been updated.</strong> Don't forget to save the claim.
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>            
            <label>Patient Attorney:</label>
            <span v-if="patient.attorney" class="font-small font-weight-bold">{{ patient.attorney.name }}</span>
            <span v-else class="text-muted font-italic font-small">No Attorney Information</span>
            <button type="button" class="btn btn-link p-0" @click="showAttorneyInfo()"><i class="fas fa-pencil-alt fa-sm"></i></button>
            <input type="hidden" name="employee_attorney" :value="attorney">
        </div>
    </div>
</template>

<script>
import { AttorneyType } from '../../constants.js';

export default {
    props: {
        isNew: Boolean,
        model: Object,
        errors: Object,
        readonly: Boolean,
        states: Array,
    },
    data() {
        return {
            AttorneyType: AttorneyType,
            patient: this.model,
            attorneyAlert: false
        }
    },
    computed: {
        attorney: function () {
            return JSON.stringify(this.patient.attorney);
        }
    }, 
    methods: {
        showAttorneyInfo: function () {
            eventHub.$emit('show-attorney-info', AttorneyType.EMPLOYEE_ATTORNEY, 'Patient', this.patient.attorney, this.updateAttorneyInfo);
        },
        updateAttorneyInfo: function (attorney) {
            this.attorneyAlert = this.attorney !== JSON.stringify(attorney);    
            this.patient.attorney = attorney;
        },
        hasError: function (name) {
            return this.errors.hasOwnProperty(name);
        },
        errorText: function (name) {
            return this.errors[name][0];
        }
    }
}
</script>

<style>
    .fa-pencil-alt {
        position: relative;
        top: -4px;
    }

    .font-small {
        font-size: .80em;
    }    
</style>